export const isTranslated = (translations, language) => {
  let isFound = false;
  translations.forEach((translation) => {
    translation.language.includes(language) && (isFound = true);
  });
  return isFound;
};
